export type StatusIndicatorType =
  | "operational"
  | "degraded"
  | "downtime"
  | "maintenance";

export interface BetterStackStatus {
  indicator: StatusIndicatorType;
  description: string;
}

export function getStatusText(indicator: StatusIndicatorType): string {
  switch (indicator) {
    case "operational":
      return "All systems normal";
    case "degraded":
      return "Partial system outage";
    case "downtime":
      return "Major outage";
    case "maintenance":
      return "Scheduled maintenance";
    default:
      return "Status unknown";
  }
}

export function getStatusColor(indicator: StatusIndicatorType): {
  bg: string;
  pulse: string;
} {
  switch (indicator) {
    case "operational":
      return { bg: "bg-emerald-500", pulse: "bg-emerald-500" };
    case "degraded":
      return { bg: "bg-amber-500", pulse: "bg-amber-500" };
    case "downtime":
      return { bg: "bg-red-500", pulse: "bg-red-500" };
    case "maintenance":
      return { bg: "bg-blue-500", pulse: "bg-blue-500" };
    default:
      return { bg: "bg-muted-foreground", pulse: "bg-muted-foreground" };
  }
}
